/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

// TODO: Where are these used?
export const signApplicationObject = (
  st: SpanTag,
  key: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/s3/application/${key}`;
  return fetchAPI(stleaf(st, 'ez2io5'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const signUserObject = (
  st: SpanTag,
  key: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/s3/user/${key}`;
  return fetchAPI(stleaf(st, 'un4qua'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getMeta = (st: SpanTag): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/s3/meta`;
  return fetchAPI(stleaf(st, 'imah1n'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

/** Which media object of the layer to sign. The API reads the key itself. */
export type SignedObjectField = 'cog' | 'pmtiles' | 'features' | 'geojson';

/**
 * `layerId` is a map layer or a legacy mission layer. For a legacy
 * processing-output child, send the parent layer id and the child `mediaId`.
 */
export const getSignedUrl = (
  st: SpanTag,
  target: { layerId: string; field: SignedObjectField; mediaId?: string },
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v2/s3/signed`;
  return fetchAPI(stleaf(st, 'sigb33'), url, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify(target),
  });
};
